var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-self-end"},[(_vm.loading)?_c('c-spinner',{staticClass:"tw-mr-4"}):_vm._e(),_vm._v(" "),_c('sort-menu-btn',{attrs:{"attributes":_vm.sortMenuBtnAttributes,"value":_vm.options},on:{"update:value":function($event){_vm.options=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }